// CORTE DIARIO (F1 reorden 24-oct-2026). Antes la tarjeta vivía dentro de Mi Negocio › Programa de lealtad,
// mezclada con las reglas del programa; es un REPORTE (resumen + Excel del día a la hora que elija el negocio),
// así que ahora tiene su pantalla bajo Análisis. La tarjeta se guarda sola (PUT /loyalty/daily-cut) y se oculta
// si quien entra no es el dueño: aquí se explica en vez de dejar la pantalla vacía.
import React from 'react';
import { CalendarClock } from 'lucide-react';
import Layout from '../../../components/layout/Layout';
import { useAuth } from '../../../context/AuthContext';
import DailyCutCard from '../../business/components/DailyCutCard';

const DailyCutPage: React.FC = () => {
  const { currentUser } = useAuth();
  const esDueno = !currentUser?.baseRole || currentUser.baseRole === 'owner';
  return (
    <Layout>
      <div className="space-y-6" data-testid="corte-diario-pagina">
        <div className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          <h1 className="text-2xl font-bold text-content flex items-center">
            <CalendarClock className="h-6 w-6 mr-2 text-accent" />
            Corte diario
          </h1>
          <p className="mt-1 text-sm text-content-2">
            Cada día, a la hora que elijas, te llega el resumen del día por sucursal y por cajero, más el Excel con cada movimiento, para cuadrar contra tu punto de venta.
          </p>
        </div>
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          {esDueno ? (
            <DailyCutCard />
          ) : (
            <div className="bg-surface p-5 rounded-lg border border-line shadow-sm text-sm text-content-2">
              El corte diario lo configura el dueño del negocio: incluye el Excel con los teléfonos de los clientes.
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default DailyCutPage;
